import React from 'react';
import classnames from 'classnames';

export default function TableBody({className, ...rest}: PropsWithClassNameOptional) {
  return <tbody className={classnames('o-table__table-body', className)} {...rest} />;
}
